export default "__VITE_ASSET__LwbQJPUv__ 800w";